import { render } from "./selected-country-counter.vue?vue&type=template&id=1ea988d2&ts=true"
import script from "./selected-country-counter.ts?vue&type=script&lang=ts&external"
export * from "./selected-country-counter.ts?vue&type=script&lang=ts&external"

import "./selected-country-counter.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__